/**
 * @class BetslipNotificationsTypes
 * @name types
 * @memberof Mojito.Services.BetslipNotifications
 */
export default class BetslipNotificationTypes {}

/**
 * Types of notifications that can be displayed in betslip.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Services.BetslipNotifications.types
 */
BetslipNotificationTypes.TYPE = {
    /** Error notification. */
    ERROR: 'error',
    /** Warning notification. */
    WARNING: 'warning',
    /** Information notification. */
    INFO: 'info',
    /** Special type used to ignore notification. */
    IGNORE: 'ignore',
};
